const URLactual = window.location.href;
let result;
if(URLactual=='http://www.app.bodeganet.cl/' || 
    URLactual=='https://www.app.bodeganet.cl/' || 
    URLactual=='http://app.bodeganet.cl/' ||
    URLactual=='https://app.bodeganet.cl/'){
    result=true
} else {
    result=false
};
export default result